import { BsModalService } from 'ngx-bootstrap/modal';
import { Component, OnInit, ElementRef, HostListener, ViewChild, Output, Input, EventEmitter } from '@angular/core';



@Component({
  selector: 'bz-date-filter',
  templateUrl: './date-filter.component.html',
  styleUrls: ['./date-filter.component.scss']
})
export class DateFilterComponent implements OnInit {
  constructor(private modalService: BsModalService) { }

  // dateMin: Date = new Date();
  dateMin2: Date = new Date();
  // dateMax: Date = new Date();
  opendateMin = false;
  opendateMax = false;
  @ViewChild('dpTo', { static: false }) dpTo: ElementRef;
  @ViewChild('dpFrom', { static: false }) dpFrom: ElementRef;
  pickers: any = { dpTo: false, dpFrom: false };

  @Input() dateMin: Date = new Date();
  @Input() dateMax: Date = new Date();
  @Input() dateMaxFuture: Date = new Date();
  @Input() titleText: string;
  @Input() isEventChange: string;
  @Input() message: string;
  @Input() showMessage: boolean = true;
  @Input() isDisabled: boolean = false;


  @Output() onBtnFilterClick = new EventEmitter();

  ngOnInit() {

    const contentElement = document.querySelector('.content');
    if (contentElement) {
      contentElement.addEventListener('click', function (e) {
        if (e.target.id === 'date-from' || e.target.id === 'date-to') {
          return;
        }

        const datePicker = document.querySelector('bs-datepicker-container');
        if (datePicker != null && this.pickers.dpFrom) {
          $('#date-from').click();
          this.pickers.dpFrom = false;
        }
        if (datePicker != null && this.pickers.dpTo) {
          $('#date-to').click();
          this.pickers.dpTo = false;
        }

      }.bind(this));
    }
  }

  public filter() {
    const dateFilter = { start: this.dateMin, end: this.dateMax };
    this.onBtnFilterClick.emit(dateFilter);
  }

  public setDatePickerActive(picker) {
    this.pickers.dpFrom = false;
    this.pickers.dpTo = false;
    this.pickers[picker] = true;
  }

  public executeFilter() {
    if (this.isValidDate(this.dateMin) && this.isValidDate(this.dateMax)) {
      this.filter();
    }
  }

  isValidDate(d) {
    return d instanceof Date && !isNaN(d.getTime());
  }
}
